var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lifeMain"},[_c('mainLeft',{attrs:{"info":_vm.info}}),_c('mainRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }